export default "__VITE_ASSET__B4wH82V4__"